<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se va a denegar la revisión del contrato, y además, se va a añadir el cliente a la Black List. Pulse "Confirmar" para
      continuar.</label>
    <button class="btn btn-primary generalPrimaryButton float-right mt-4" data-dismiss="modal" aria-label="Close" @click="deny()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'DenyBLContractDetail',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId',
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
    deny(){
      let bodyToSend = {
        contractId: this.contractId,
        status: 'DENIED',
        blacklist: true
      }
      axios.put(`/contract/validation/update-status`, bodyToSend)
        .then(() => {

        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
